import { GetUnitsQueryArg } from '../types/query-arg';
import { GetUnitsQueryParams } from '../types/query-params';

export const getUnitsQueryParams = (
  queryArg: GetUnitsQueryArg,
): GetUnitsQueryParams => ({
  organisationId: queryArg.organisation.id,
});
